/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Form/Create
 * @desc Create Action for experiment workflow
 */

import {
  fieldExperimentWorkflowNameWithLabel,
  fieldExperimentWorkflowPlannedAt,
  getFieldExperimentWorkflowTemplate,
} from 'labstep-web/components/ExperimentWorkflow/Form/fields';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { ExperimentWorkflowFormCreateProps } from './types';

export const ExperimentWorkflowFormCreate: React.FC<
  ExperimentWorkflowFormCreateProps
> = ({ defaultValues, activeGroup, options, ...rest }) => {
  const fields = [
    fieldExperimentWorkflowNameWithLabel,
    fieldExperimentWorkflowPlannedAt,
    getFieldExperimentWorkflowTemplate(activeGroup!.id),
  ];

  return (
    <FormCreate
      entityName={ExperimentWorkflow.entityName}
      defaultValues={defaultValues}
      fields={fields}
      options={options}
      autoFocus
      {...rest}
    />
  );
};

export default withActiveGroup(ExperimentWorkflowFormCreate);
